export default "__VITE_ASSET__dc81805d__"